// Modules
import React from "react";
import PropTypes from "prop-types";

const LogoSecondary = (props) => {
	const { clssName } = props;

	return (
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			viewBox="0 0 380 440"
			className={clssName}
		>
			<path d="M180.52,306.17v-76.28c0-11.7,1.29-19.46,3.88-23.29c2.58-3.82,8.27-5.74,17.04-5.74c11.7,0,20.14,4.22,25.31,12.66
	c5.17,8.44,7.77,20.98,7.77,37.63c0,9.68-1.13,18.73-3.38,27.17c-2.25,8.44-6.19,15.19-11.81,20.25c-5.63,5.07-13.73,7.6-24.3,7.6
	H180.52z M180.52,311.9h14.17c20.03,0,34.37,4.73,43.03,14.17c8.66,9.46,13,22.85,13,40.17c0,18.9-3.78,33.48-11.31,43.71
	c-7.54,10.24-19.41,15.36-35.61,15.36c-9.68,0-15.98-1.74-18.9-5.24c-2.92-3.49-4.38-11.08-4.38-22.78V311.9z M188.12,6.89L6,158.2
	v273.94h128.37c6.31-0.04,12.69-0.07,19.15-0.07c14.17,0,26.38,0.16,36.62,0.51c10.24,0.33,18.07,0.51,23.46,0.51
	c29.03,0,51.81-5.63,68.34-16.88c16.55-11.25,24.81-27.45,24.81-48.6c0-9.23-2.69-18.11-8.1-26.67
	c-5.4-8.55-14.29-15.87-26.66-21.94c-12.38-6.07-29.15-9.89-50.29-11.47v-0.68c15.75-2.92,28.57-7.54,38.47-13.83
	c9.91-6.31,17.21-13.51,21.94-21.61c4.73-8.1,7.09-16.08,7.09-23.97c0-15.52-6.91-28.23-20.76-38.14
	c-13.84-9.89-34.71-14.84-62.62-14.84c-4.27,0-11.47,0.12-21.6,0.33c-10.12,0.23-20.6,0.33-31.39,0.33c-9.46,0-18.96-0.1-28.52-0.33
	c-9.58-0.22-17.17-0.45-22.78-0.68v6.75c6.97,0.23,12.31,1.07,16.03,2.53c3.72,1.46,6.19,4.17,7.42,8.1
	c1.24,3.93,1.87,10.07,1.87,18.4V397.3c0,8.1-0.62,14.17-1.87,18.22c-1.23,4.05-3.66,6.75-7.25,8.1c-0.77,0.29-2.5,0.55-3.43,0.8
	H15.6V162.7L188.16,19.33l175.28,143.4v269.41h9.59V158.17L188.12,6.89z"/>
		</svg>
	);
};

LogoSecondary.propTypes = {
	clssName: PropTypes.string,
};

LogoSecondary.defaultProps = {
	clssName: "",
};

export default LogoSecondary;
